import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import ServicesOverview from "./pages/ServicesOverview";
import ServiceDetail from "./pages/ServiceDetail";
import IndustriesOverview from "./pages/IndustriesOverview";
import IndustryDetail from "./pages/IndustryDetail";
import Work from "./pages/Work";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/site/ScrollToTop";
import MetaPixelTracker from "./components/site/MetaPixelTracker";
import CookieConsent from "./components/site/CookieConsent";

const Admin = lazy(() => import("./pages/Admin"));
const Events = lazy(() => import("./pages/Events"));

function App() {
  return (
    <BrowserRouter>
      <MetaPixelTracker />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        
        {/* Dedicated About Route */}
        <Route path="/about" element={<About />} />
        <Route path="/about/" element={<Navigate to="/about" replace />} />

        {/* Dedicated Service Routes */}
        <Route path="/services" element={<ServicesOverview />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/services/" element={<Navigate to="/services" replace />} />

        {/* Dedicated Industry Routes */}
        <Route path="/industries" element={<IndustriesOverview />} />
        <Route path="/industries/:slug" element={<IndustryDetail />} />
        <Route path="/industries/" element={<Navigate to="/industries" replace />} />

        {/* Dedicated Work / Portfolio Route */}
        <Route path="/work" element={<Work />} />
        <Route path="/work/" element={<Navigate to="/work" replace />} />

        {/* Dedicated Events Route */}
        <Route
          path="/events"
          element={
            <Suspense
              fallback={
                <div className="flex min-h-screen items-center justify-center bg-white">
                  <div className="font-display text-xl font-bold uppercase tracking-widest text-[#0B132B]/40">
                    ADMALL EVENTS
                  </div>
                </div>
              }
            >
              <Events />
            </Suspense>
          }
        />
        <Route path="/events/" element={<Navigate to="/events" replace />} />

        {/* Dedicated Contact Route */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/contact/" element={<Navigate to="/contact" replace />} />

        {/* Admin Route */}
        <Route
          path="/admin"
          element={
            <Suspense
              fallback={
                <div className="flex min-h-screen items-center justify-center bg-[#0B132B]">
                  <div className="font-display text-xl font-bold uppercase tracking-widest text-white/50">
                    ADMALL INDIA
                  </div>
                </div>
              }
            >
              <Admin />
            </Suspense>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
